@if (!error) {
<form [formGroup]="beneficiaryForm">
  @if (loading) {
  <div class="mt-1">
    <div class="skeleton_item skeleton_100"></div>
  </div>
  <div class="mt-1">
    <div class="skeleton_item skeleton_100"></div>
  </div>
  }
  <div *ngIf="!loading" class="pointer-events-none">
    <!-- Account Details Form Group -->
    <div
      formGroupName="accountDetails"
      class="finxForm"
      [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
    >
      @for (field of inputFieldConfigs; track field.name) {
      <finxone-input
        *ngIf="field?.validation?.required"
        [type]="field.type"
        [label]="field.label"
        [value]="beneficiaryForm.get('accountDetails')?.get(field.name)?.value"
        [formControlName]="field.name"
        [formControlInvalid]="
          !!(
            beneficiaryForm.get('accountDetails')?.get(field.name)?.invalid &&
            beneficiaryForm.get('accountDetails')?.get(field.name)?.touched
          )
        "
        [validationConfig]="beneficiaryFormService.getValidationConfig(field.validation)"
      ></finxone-input>
      }
    </div>
  </div>
</form>
} @else { Form not found }
